import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableHead, TableRow, Grid, FormHelperText } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import { withTranslation } from 'react-i18next';
import ContactModeRowComponent from './ContactModeRowComponent';
import { isValid } from '@totalsoft/pure-validations-react';
import { withRights } from 'providers/RightsConsumer';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { GridActionsWrapper } from 'components/common/CommonStyles';

export const ContactModeListComponent = ({
  t,
  contactModes,
  contactModeTypes,
  addContactMode,
  deleteContactMode,
  onPropertyChange,
  saveContactModeList,
  validation,
  isDirty,
  rights,
  validDefault,
  saving
}) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <CardNoResultsWrapper content={contactModes} overflow='auto'>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ paddingRight: '150px' }} colSpan={4}>
                  <strong>{t('OfferEdit.Client.ContactMode.Type')}</strong>
                </TableCell>
                <TableCell style={{ paddingRight: '200px' }} colSpan={4}>
                  <strong>{t('OfferEdit.Client.ContactMode.Value')}</strong>
                </TableCell>
                <TableCell style={{ textAlign: 'center' }} colSpan={2}>
                  <strong> {t('OfferEdit.Client.ContactMode.SMSNotification')}</strong>
                </TableCell>
                <TableCell style={{ textAlign: 'center' }} colSpan={2}>
                  <strong>{t('OfferEdit.Client.ContactMode.Default')}</strong>
                </TableCell>
                <TableCell colSpan={1}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contactModes.map((contactMode, idx) => {
                return (
                  <ContactModeRowComponent
                    key={contactMode.partnerContactModeId ? `${contactMode.partnerContactModeId}` : `${idx}`}
                    idx={idx}
                    contactMode={contactMode}
                    contactModeTypes={contactModeTypes}
                    addContactMode={addContactMode}
                    deleteContactMode={deleteContactMode}
                    onPropertyChange={onPropertyChange(idx)}
                    validation={validation[idx]}
                    rights={rights}
                  />
                );
              })}
            </TableBody>
          </Table>
        </CardNoResultsWrapper>
        {!validDefault.email && (
          <FormHelperText error={true} id='email-error'>
            {t('OfferEdit.Client.ContactMode.ValidateUniqueDefaultEmail')}
          </FormHelperText>
        )}
        {!validDefault.mobile && (
          <FormHelperText error={true} id='mobile-error'>
            {t('OfferEdit.Client.ContactMode.ValidateUniqueDefaultMobilePhone')}
          </FormHelperText>
        )}
        {!validDefault.phone && (
          <FormHelperText error={true} id='phone-error'>
            {t('OfferEdit.Client.ContactMode.ValidateUniqueDefaultPhone')}
          </FormHelperText>
        )}
        <GridActionsWrapper mt={2}>
          <Button
            id='contactMode_addBtn'
            color='primary'
            variant='contained'
            disabled={rights.readOnlyFull || !rights.clientContactmodeWrite}
            onClick={addContactMode}
          >
            {t('Add')}
          </Button>
          <Button
            id='contactMode_saveBtn'
            color='primary'
            variant='contained'
            disabled={rights.readOnlyFull || !isDirty || !isValid(validation) || saving || !rights.clientContactmodeWrite}
            onClick={saveContactModeList}
          >
            {saving ? t('Saving') : t('Save')}
          </Button>
        </GridActionsWrapper>
      </Grid>
    </Grid>
  );
};

ContactModeListComponent.propTypes = {
  t: PropTypes.func.isRequired,
  contactModes: PropTypes.array.isRequired,
  contactModeTypes: PropTypes.array.isRequired,
  addContactMode: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  deleteContactMode: PropTypes.func.isRequired,
  saveContactModeList: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  isDirty: PropTypes.bool.isRequired,
  rights: PropTypes.object.isRequired,
  validDefault: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired
};

export default withTranslation()(withRights(ContactModeListComponent));
